
export const backendUrl = process.env.REACT_APP_BACKEND_URL;
// export const backendUrl = 'http://localhost:8080';


export const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
